/**
 * The line the progress window shows once the server has the bulk run.
 *
 * It lives here rather than inline in the screen because it is the sentence this whole change
 * exists to earn, and because there are TWO of them: a deployment whose worker will carry the run
 * on, and one where the acceptance is durable and nothing is going to move until a person turns the
 * worker on. Both are real states, and telling an operator to shut their computer in the second one
 * would be the product promising work nobody is doing.
 *
 * Inline, the choice had no test that could fail: deleting the branch left every suite green while
 * the one sentence that must stay honest started lying. A function has one.
 */
export function runAcceptedNotice(processing: boolean): string {
  return processing
    ? 'İşlem sunucuda başlatıldı. Bu sayfayı kapatabilirsiniz.'
    : 'İşlem sunucuda kaydedildi ama bu dağıtımda arka plan üretimi kapalı; bir yetkili açana kadar beklemede kalır.';
}
